import axios from "../utils/axios-interceptor";

export const getConversionHistoryApi = async(payload) => {
  const res = await axios.get(`/get_conversion_details?username=${payload.username}`);
  const data = await res.data
  return data
}

export const getConversionDetailsViewApi = async(payload) => {
  try {
    const res = await axios.post("/get_conversion_details_view", payload);
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(`Error: ${error.message}`);
  }
}

export const getDeleteConversionDetailsApi = async(payload) => {
  try {
    const res = await axios.post("/delete_conversion_details", payload);
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(`Error: ${error.message}`);
  }
}